import axios from "axios";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";
import { LMS_BASE_URL } from "../../../../utils/http/http-common";
import { getLMSData } from "../../../../utils/getLMSData";

export const getChapterByModuleApiCall = async (args) => {
  const { courseId, languageId = 1, moduleId } = args;

  const authToken = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/chapter/by-module?courseId=${courseId}&languageId=${languageId}&moduleId=${moduleId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    const {response} = error || {};
        
    if(response?.data?.statusCode  === 401){
        getLMSData();
    }
    return error.config.data;
  }
};
